/* APP-LIKE FEEL (independent of any festival theme)
   1. Prefetch the next page when a finger/mouse is on a link
   2. Image skeleton: shimmer until the picture is there
   3. Infinite scroll on collection / search pages
   4. Back-to-top button                                         */
(function () {
  if (window.__nvSpeed) return;
  window.__nvSpeed = true;

  var cfg = window.nvSpeed || {};
  var root = document.documentElement;
  var conn = navigator.connection || {};
  var slow = !!(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. prefetch ---------- */
  if (cfg.prefetch !== false && !slow) {
    (function () {
      var spec = window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
      if (spec) { // Chrome / Edge / Android browsers
        var s = document.createElement('script');
        s.type = 'speculationrules';
        s.textContent = JSON.stringify({
          prefetch: [{
            where: { and: [
              { href_matches: ['/products/*', '/collections/*', '/pages/*', '/blogs/*'] },
              { not: { selector_matches: ['[target=_blank]', '[download]', '[data-no-prefetch]'] } }
            ] },
            eagerness: 'moderate'
          }]
        });
        document.head.appendChild(s);
        return;
      }
      var rl = document.createElement('link').relList;
      if (!(rl && rl.supports && rl.supports('prefetch'))) return;
      var done = {}, count = 0, OK = /^\/(products|collections|pages|blogs)(\/|$)/;
      function prefetch(a) {
        if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return;
        var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
        if (u.origin !== location.origin || !OK.test(u.pathname)) return;
        if (u.pathname === location.pathname && u.search === location.search) return;
        if (/(^|&)(sections|section_id|view)=/.test(u.search.slice(1))) return;
        if (done[u.href] || count > 25) return;
        done[u.href] = 1; count++;
        var l = document.createElement('link'); l.rel = 'prefetch'; l.href = u.href; l.as = 'document';
        document.head.appendChild(l);
      }
      document.addEventListener('touchstart', function (e) { prefetch(e.target.closest && e.target.closest('a')); }, { passive: true, capture: true });
      var timer;
      document.addEventListener('mouseover', function (e) {
        var a = e.target.closest && e.target.closest('a'); if (!a) return;
        clearTimeout(timer); timer = setTimeout(function () { prefetch(a); }, 80);
      }, { passive: true });
    })();
  }

  /* ---------- 2. image skeleton ---------- */
  function mark(img) { img.classList.add('nv-ok'); }
  document.addEventListener('load', function (e) {
    var t = e.target; if (t && t.tagName === 'IMG') mark(t);
  }, true);
  function scanImages() {
    var imgs = document.images;
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].complete && imgs[i].naturalWidth) mark(imgs[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanImages); else scanImages();

  /* ---------- 3. infinite scroll ---------- */
  if (cfg.infinite !== false) {
    (function () {
      var GRID = 'ul#product-grid, ul.product-grid';
      if (!document.querySelector(GRID)) return;
      var loading = false, failed = false, usedInf = false, lastGrid = null, more = null, ticking = false;

      function wrapper() { return document.querySelector('.pagination-wrapper'); }
      function nextHref() {
        var w = wrapper(); if (!w) return null;
        var cur = Number(w.getAttribute('data-page')) || 1;
        var links = w.querySelectorAll('a[href]');
        for (var i = 0; i < links.length; i++) {
          var u; try { u = new URL(links[i].href, location.href); } catch (e) { continue; }
          if (Number(u.searchParams.get('page')) === cur + 1) return u.href;
        }
        return null;
      }
      function setMore(on) {
        var g = document.querySelector(GRID);
        if (!g) return;
        if (!more) { more = document.createElement('div'); more.className = 'nv-more'; more.setAttribute('role', 'status'); more.innerHTML = '<span class="nv-more__dot"></span><span class="nv-more__dot"></span><span class="nv-more__dot"></span>'; }
        if (on) { g.insertAdjacentElement('afterend', more); } else if (more.parentNode) { more.parentNode.removeChild(more); }
      }
      function check() {
        var g = document.querySelector(GRID);
        if (!g) return;
        if (g !== lastGrid) { lastGrid = g; failed = false; } // filters re-draw the grid
        var has = !!nextHref();
        root.classList.toggle('nv-inf', (has || usedInf) && !failed); // hide numbered pagination while auto-loading
        if (!has || loading || failed) return;
        var last = g.lastElementChild; if (!last) return;
        if (last.getBoundingClientRect().top < window.innerHeight + 900) loadNext();
      }
      function loadNext() {
        var url = nextHref(), g = document.querySelector(GRID);
        if (!url || !g) return;
        loading = true; setMore(true);
        fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('x'); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.querySelector(GRID);
          if (!ng || !ng.children.length) throw new Error('x');
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(ng.children, function (li) {
            var n = document.importNode(li, true);
            n.className = n.className.replace(/\b(scroll-trigger[\w-]*|animate--[\w-]+)\b/g, '').replace(/\s+/g, ' ').trim();
            n.removeAttribute('data-cascade');
            frag.appendChild(n);
          });
          g.appendChild(frag);
          usedInf = true;
          var nw = doc.querySelector('.pagination-wrapper'), ow = wrapper();
          if (ow) { if (nw) ow.replaceWith(document.importNode(nw, true)); else ow.parentNode.removeChild(ow); }
          document.dispatchEvent(new CustomEvent('nv:grid-updated'));
        }).catch(function () {
          failed = true; root.classList.remove('nv-inf'); // fall back to normal numbered pages
        }).then(function () {
          loading = false; setMore(false);
          scanImages();
          setTimeout(check, 50);
        });
      }
      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; check(); }); }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      document.addEventListener('DOMContentLoaded', check);
      setTimeout(check, 400);
    })();
  }

  /* ---------- 4. back to top ---------- */
  if (cfg.backToTop !== false) {
    (function () {
      function init() {
        if (document.querySelector('product-info')) return; // product pages have the sticky buy bar
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'nv-top'; b.setAttribute('aria-label', 'Back to top');
        b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 15 7-7 7 7"/></svg>';
        document.body.appendChild(b);
        var last = window.scrollY, shown = false;
        function set(v) { if (v !== shown) { shown = v; b.classList.toggle('is-on', v); } }
        window.addEventListener('scroll', function () {
          var y = window.scrollY, h = window.innerHeight;
          if (y < h * 0.8) set(false);
          else if (y < last - 6) set(true);   // scrolling up
          else if (y > last + 14) set(false); // scrolling down
          last = y;
        }, { passive: true });
        b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
      }
      if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
    })();
  }
})();
